export default {
  name: {
    id: 'rm_metal_chromium_name',
    defaultMessage: 'Chromium',
  },
  smartphoneLabel: {
    id: 'rm_metal_chromium_smartphone_label',
    defaultMessage: 'Significant',
  },
  whatItDoesText: {
    id: 'rm_metal_chromium_what_it_does',
    defaultMessage:
      'Chromium makes stainless steel resistant to corrosion, wear and high temperatures. It also increases the strength and durability of steel used in electrical equipment, machinery, construction and other products.',
  },
  extractionText1: {
    id: 'rm_metal_chromium_extraction_p1',
    defaultMessage:
      'Chromium is extracted from chromite ore, a mineral containing chromium and iron. The ore is mined, crushed and processed into ferrochrome, an alloy used mainly to produce stainless steel. In South Africa, some chromite is also recovered from waste left by platinum-group metal operations.',
  },
  quickFactText: {
    id: 'rm_metal_chromium_quick_fact',
    defaultMessage:
      'On a per-kilogram basis, chromium production ranks among the lowest of 63 metals for several impact categories, including global warming potential. However, its relatively large annual production volume places its total global warming impact 11th among the 63 metals.',
  },
  envSummaryText: {
    id: 'rm_metal_chromium_env_summary',
    defaultMessage:
      'Chromium mining and processing can disturb land, consume water and energy, generate waste and release pollutants. Ferrochrome, an alloy produced by processing chromium ore, is energy-intensive. Hexavalent chromium, or Cr(VI), is a particularly hazardous form associated with carcinogenic effects and damage to the respiratory system, skin and kidneys.',
  },
  envWaterText: {
    id: 'rm_metal_chromium_env_water_text',
    defaultMessage:
      'Hexavalent chromium, or Cr(VI), is a particularly hazardous form of chromium that can pollute water and harm human health. The European Union’s maximum discharge limits are 1 mg per litre for Cr(VI) and 5 mg per litre for total chromium.',
  },
  envSoilText: {
    id: 'rm_metal_chromium_env_soil_text',
    defaultMessage:
      'Surface mining can remove vegetation and topsoil, increasing erosion and generating waste rock and tailings. Chromium-bearing residues, particularly those containing Cr(VI), may contaminate soil and groundwater.',
  },
  envClimateText: {
    id: 'rm_metal_chromium_env_climate_text',
    defaultMessage:
      'On a per-kilogram basis, chromium production ranks among the lowest of 63 metals for global warming potential. However, its large annual production volume gives chromium the 11th-highest total global warming impact among these metals.',
  },
  humanSummaryText: {
    id: 'rm_metal_chromium_human_summary',
    defaultMessage:
      'The main human risk comes from exposure to hexavalent chromium, or Cr(VI), during mining, processing and industrial use. Exposure through inhalation or ingestion can damage the skin, respiratory system and kidneys and increase the risk of cancer.',
  },
  humanHealthText: {
    id: 'rm_metal_chromium_human_health_text',
    defaultMessage:
      'Hexavalent chromium exposure can cause skin ulceration, dermatitis, nasal damage, respiratory irritation, kidney injury and lung cancer.',
  },
  humanLegalText: {
    id: 'rm_metal_chromium_human_legal_text',
    defaultMessage:
      'The EU strictly controls hexavalent chromium (Cr(VI)) because it can harm human health and the environment. Some industrial uses are restricted, and further limits have been proposed. The EU also limits chromium discharges into water to 1 mg/L for Cr(VI) and 5 mg/L for total chromium.',
  },
  geoSummaryText: {
    id: 'rm_metal_chromium_geo_summary',
    defaultMessage:
      'Chromium supply is concentrated at both the mining and processing stages. South Africa dominates chromite mining, while China leads ferrochrome production. Because more than 80% of ferrochrome is used to produce stainless steel, chromium demand and supply are closely tied to the steel industry.',
  },
  geoDugText: {
    id: 'rm_metal_chromium_geo_dug_text',
    defaultMessage:
      'South Africa, Turkey and Kazakhstan together accounted for approximately 75% of global marketable chromite production in 2024. Chromium is mainly mined as a primary product, although some South African chromite is recovered from platinum-group mining waste.',
  },
  geoProcessedText: {
    id: 'rm_metal_chromium_geo_processed_text',
    defaultMessage:
      'China accounts for around 53% of global chromium processing, followed by South Africa at 20% and Kazakhstan at 10%. Processing mainly produces ferrochrome, which is used in stainless steel.',
  },
  geoLeverageText: {
    id: 'rm_metal_chromium_geo_leverage_text',
    defaultMessage:
      'Zimbabwe has banned exports of chromium ore since 2021. South Africa, China and India also require licences for some chromium exports. These measures can reduce the amount of ore available to importing regions.',
  },
  supplySummaryText: {
    id: 'rm_metal_chromium_supply_summary',
    defaultMessage:
      'Chromium supply is currently large, but future availability depends on the steel industry and on a small number of producing countries. Global chromite production increased by approximately 4% between 2023 and 2024. However, South African producers face electricity, labour, rail and deep-level mining challenges, while export restrictions and growing domestic processing could reduce the volume available to importing regions.',
  },
  supplyReservesText: {
    id: 'rm_metal_chromium_supply_reserves_text',
    defaultMessage:
      'Identified global chromium resources exceed 12 billion tonnes of shipping-grade chromite, equivalent to approximately 3.7 billion tonnes of chromium content. Reserves are estimated at more than 1.2 billion tonnes of shipping-grade chromite, equivalent to around 371 million tonnes of chromium content. These figures concern chromite, not refined chromium metal.',
  },
  supplyDemandText: {
    id: 'rm_metal_chromium_supply_demand_text',
    defaultMessage:
      'Overall chromium demand is expected to grow with stainless-steel production, which accounts for most ferrochrome use. Demand from clean-energy technologies is expected to surge by 2030 and then stabilise, increasing by approximately 93% between 2025 and 2050.',
  },
  recyclingSummaryText: {
    id: 'rm_metal_chromium_recycling_summary',
    defaultMessage:
      'There is no dedicated recycling system for pure chromium metal because most chromium is used in alloys. Stainless steel, which accounts for around 70% of European chromium use, is highly recyclable. Its post-consumer functional recycling rate ranges from 70% to 95%, depending on the product.',
  },
  recyclingInputText: {
    id: 'rm_metal_chromium_recycling_input_text',
    defaultMessage:
      'In the European Union, chromium’s end-of-life recycling input rate was around 30% in 2020. Stainless-steel production used approximately 60% scrap, comprising around 25% old scrap from discarded products and 35% new manufacturing scrap.',
  },
  recyclingOutlookText: {
    id: 'rm_metal_chromium_recycling_outlook_text',
    defaultMessage:
      'Partly, but not completely. Stainless steel can be recycled at high rates, but alloy products are harder to identify and sort. Some chromium-containing alloys are therefore mixed into ordinary steel, losing their original properties. Recycling can reduce the need for new chromium, but it cannot replace primary production entirely.',
  },
  footnote1Text1: {
    id: 'rm_metal_chromium_footnote_1_p1',
    defaultMessage:
      'As chromium is not covered by the ADEME 2024 study, its environmental, social, geopolitical and supply-risk scores were calculated by Back Market’s Sustainability team using ADEME’s methodology, public sources and AI assistance. These scores carry greater uncertainty. See the Sources tab for the full methodology and references.',
  },
} as const
